import { Link } from 'react-router-dom';

export default function CapacitacionCultura() {
  const programs = [
    {
      icon: 'ri-shield-user-line',
      title: 'Cursos Legales Obligatorios',
      description: 'Capacitaciones requeridas por ley para cumplimiento normativo.',
      duration: '4-16 horas'
    },
    {
      icon: 'ri-anchor-line',
      title: 'Trabajo en Altura',
      description: 'Uso de EPP, sistemas anticaídas y procedimientos seguros.',
      duration: '16 horas'
    },
    {
      icon: 'ri-flashlight-line',
      title: 'Espacios Confinados',
      description: 'Identificación de riesgos y protocolos de entrada segura.',
      duration: '12 horas'
    },
    {
      icon: 'ri-first-aid-kit-line',
      title: 'Primeros Auxilios',
      description: 'Capacitación en respuesta ante emergencias médicas.',
      duration: '16 horas'
    },
    {
      icon: 'ri-tools-line',
      title: 'Entrenamientos Operacionales',
      description: 'Formación específica para operación de equipos y maquinaria.',
      duration: 'Variable'
    },
    {
      icon: 'ri-team-line',
      title: 'Capacitación para Contratistas',
      description: 'Programas adaptados para personal de empresas contratistas.',
      duration: 'Variable'
    }
  ];

  const methodology = [
    {
      icon: 'ri-book-open-line',
      title: 'Teoría Aplicada',
      description: 'Contenidos técnicos adaptados a la realidad de tu industria'
    },
    {
      icon: 'ri-tools-fill',
      title: 'Práctica en Terreno',
      description: 'Ejercicios prácticos y simulacros en condiciones reales'
    },
    {
      icon: 'ri-refresh-line',
      title: 'Seguimiento',
      description: 'Evaluaciones periódicas y reforzamiento continuo'
    }
  ];

  return (
    <section id="capacitacion" className="py-24 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <div className="inline-block bg-teal-100 text-teal-700 px-4 py-2 rounded-full text-sm font-semibold mb-6">
            Formación Profesional
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Capacitación y <span className="text-teal-600">Entrenamiento</span>
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Impartimos cursos legales obligatorios y entrenamientos operacionales para personal propio y contratistas.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center mb-20">
          <div className="relative order-2 lg:order-1">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl">
              
<img
  src="/images/services/capacitacion-operacional.webp"
  alt="Capacitación y Entrenamiento"
  width={900}
  height={1100}
  loading="lazy"
  decoding="async"
  className="w-full h-full object-cover object-center"
/>

            </div>
          </div>

          <div className="order-1 lg:order-2">
            <h3 className="text-3xl font-bold text-gray-900 mb-6">
              Formación práctica y especializada
            </h3>
            <p className="text-base text-gray-600 mb-6 leading-relaxed">
              Desarrollamos programas de capacitación que cumplen con requisitos legales y necesidades operacionales específicas. Nuestros cursos combinan teoría con práctica intensiva para garantizar que tu personal adquiera las competencias necesarias para trabajar de forma segura.
            </p>
            <p className="text-base text-gray-600 mb-8 leading-relaxed">
              Capacitamos tanto a personal propio como a contratistas, adaptando contenidos y metodologías según el nivel de experiencia y los riesgos específicos de cada operación.
            </p>

            <div className="grid grid-cols-2 gap-4 mb-8">
              {methodology.map((item, index) => (
                <div key={index} className="bg-white rounded-lg p-4 border border-gray-200">
                  <div className="w-10 h-10 bg-teal-100 rounded-lg flex items-center justify-center mb-3">
                    <i className={`${item.icon} text-xl text-teal-600`}></i>
                  </div>
                  <h4 className="text-sm font-bold text-gray-900 mb-1">{item.title}</h4>
                  <p className="text-xs text-gray-600">{item.description}</p>
                </div>
              ))}
            </div>

            <Link
              to="/contacto"
              className="bg-teal-600 text-white px-8 py-3.5 rounded-lg text-base font-semibold hover:bg-teal-700 transition-colors inline-flex items-center gap-2 whitespace-nowrap shadow-lg focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-teal-500"
            >
              Hablar con un asesor
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </div>

        <div>
          <h3 className="text-3xl font-bold text-gray-900 mb-8 text-center">
            Programas de Capacitación
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {programs.map((program, index) => (
              <div 
                key={index}
                className="bg-white rounded-xl p-6 shadow-md hover:shadow-xl transition-all border border-gray-100 hover:-translate-y-1"
              >
                <div className="flex items-start justify-between mb-4">
                  <div className="w-14 h-14 bg-gradient-to-br from-teal-500 to-teal-600 rounded-lg flex items-center justify-center">
                    <i className={`${program.icon} text-2xl text-white`}></i>
                  </div>
                  <span className="bg-teal-100 text-teal-700 px-3 py-1 rounded-full text-xs font-semibold">
                    {program.duration}
                  </span>
                </div>
                <h3 className="text-lg font-bold text-gray-900 mb-2">
                  {program.title}
                </h3>
                <p className="text-gray-600 text-sm leading-relaxed">
                  {program.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}